import { fetchApi } from "../DataApi/fetchApi";

export async function destroySession() {
  try {
    const origin = window.location.origin;
    const endpoint = "/web/session/destroy";
    const url = `${origin}${endpoint}`;
    console.log("destroySession API called", url);

    const response = await fetch(url, {
      method: "POST", // Ensure this is POST
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}), // Send empty JSON body to prevent "Invalid JSON data" error
    });

    if (!response.ok) {
      throw new Error(
        `Logout failed: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    console.log("Logout successful:", data);
    return data;
  } catch (error) {
    console.error("An error occurred during logout:", error);
    throw error;
  }
}
